import { IRecallFromQuotationApi } from '@core/interface';
import { QuotationDetail } from './quotation-detail.model';

export interface IQuotationScheduleDetailVO {
  quotationId: number;
  dealerQuotation: number;
  status: number;
  country: string;
  division: number;
  dealer: number;
  advisor: number;
  scheduleDate: Date;
  scheduleHour: number;
  createDate: string;
  requestedItems: QuotationDetail;
  recommendedItems: QuotationDetail;
  complementaryBudget: QuotationDetail;
  checklistId: number;
  totalQuotation: number;
  remarks: string;
  customerRemarks: string;
  customerSign: string;
  dealerSign: string;
  update: string;
  scheduleRecalls: IRecallFromQuotationApi[];
  customerWaitingInDealer?: string;
}
